import React from 'react';
import Rimg from './Rimg.jsx';
import ProductMobileGallery from './ProductMobileGallery.jsx';
import MediaQuery from 'react-responsive';
import ProductContext from './ProductContext.jsx';
import SVG from './SVG.jsx';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import trackEvent from '../utils/trackEvent';
import ProductVideo from './ProductVideo.jsx';

class FeaturedMedia extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { featuredLoaded: true };

    this._featuredLoaded = this._featuredLoaded.bind(this);
    this.mediaMarkup = this.mediaMarkup.bind(this);
  }

  _featuredLoaded(e) {
    this.setState({ featuredLoaded: true })
  }

  componentDidUpdate(prevProps) {
    const featured = this.props.media;
    const prevFeatured = prevProps.media;

    if (prevFeatured.src !== featured.src) {
      this.setState({ featuredLoaded: false });
    }
  }

  componentDidMount() {
    trackEvent('ProductImageView', { imageIndex: (this.props.index + 1), imageSrc: this.props.media.src, handle: this.props.handle });
  }

  mediaMarkup(featured, cName) {
    if (featured.media_type === 'model') {
      return <div className="container product-main-image model-wrap">
        <model-viewer camera-controls="true" poster={featured.preview_image} src={featured.sources[0].url} data-shopify-feature="1.2" data-js-focus-visible ar-status="not-presenting"></model-viewer>
      </div>
    }

    if (featured.media_type === 'video') {
      return <ProductVideo featured={featured} handle={this.props.handle} productName={this.props.productName} />
    }

    return <Rimg src={featured.src} fetchPriority="high" loading="eager" width={featured.width} height={featured.height} className={cName} data-image-zoom={featured.id} onClick={(e) => { this.props._openImageZoom(featured.id, e.currentTarget) }} onLoad={this._featuredLoaded} alt={featured.alt || this.props.productName} sizes="(min-width: 960px) 42vw, (min-width: 1555px) 655px, 52.5vw" />
  }

  render() {
    const featured = this.props.media;
    return <div className="image-wrap">
      <SwitchTransition
        mode='in-out'>
        <CSSTransition
          key={this.state.featuredLoaded && featured.id}
          addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
          classNames="fade">
          {this.mediaMarkup(featured, 'featured-image current-image')}
        </CSSTransition>
      </SwitchTransition>
      <button onClick={(e) => { this.props._openImageZoom(featured.id, e.currentTarget) }} className="image-zoom-trigger">
        <SVG icon="search" />
        <i>{this.context.i18n.zoomImage}</i>
      </button>
    </div>
  }
}

FeaturedMedia.contextType = ProductContext;

export default class ProductGallery extends React.PureComponent {
  constructor(props) {
    super();
    this.state = { index: 0 };
    this.mediaThumbnails = this.mediaThumbnails.bind(this);
    // this.productMediaTrigger = this.productMediaTrigger.bind(this);
    this.imageZoom = null;
    this._openImageZoom = props._openImageZoom;
    this._changeImage = this._changeImage.bind(this);
  }

  mediaThumbnails() {
    if (this.props.media.length > 1) {
      return <ul className="pager">
        {this.props.media.map((media, i) => {
          let cName = 'thumb wrap';
          let clickHandler = (e) => { this._changeImage(i, media) };
          if (this.state.index === i) {
            cName += ' active';
          }
          let mediaIcon = null;
          if (media.media_type === 'model') {
            mediaIcon = <span className="play-media">
              <SVG icon="3d" />
            </span>
          }
          if (media.media_type === 'video') {
            mediaIcon = <span className="play-media">
              <SVG icon="video" />
              {media.alt && <span className="play-media-label">{media.alt}</span>}
            </span>
          }
          return <li className={cName} key={i} onClick={clickHandler}>
            {mediaIcon}
            <Rimg src={media.preview_image.src} loading="lazy" width={media.preview_image.width} height={media.preview_image.height} className="thumb" alt={media.alt || this.props.productName} sizes="75px" />
            <span className="overlay"></span>
          </li>
        })}
      </ul>
    }
    return (null)
  }

  /* productMediaTrigger() {
    if (this.props.productVideo) {
      return <button className="product-media-trigger" onClick={this.props._openProductVideoModal}><SVG icon="video" />{this.props.productVideo.alt}</button>
    }
    return (null);
  } */

  _changeImage(i, media) {
    this.setState({ index: i });
    trackEvent('ProductImageView', { imageIndex: (i + 1), imageSrc: media.src, handle: this.props.handle });
  }

  componentWillUnmount() {
    if (this.imageZoom) {
      this.imageZoom.unload();
    }
  }

  render() {
    if (!this.props.media) {
      return null;
    }
    const featured = this.props.overlay && this.props.overlay.media || this.props.media[this.state.index];
    return <React.Fragment>
      <MediaQuery maxWidth={719}>
        <ProductMobileGallery {...this.props} _openImageZoom={this._openImageZoom} />
      </MediaQuery>
      <MediaQuery minWidth={720}>
        <div className="product-gallery">
          <this.mediaThumbnails />
          <div className="container product-main-image">
            <FeaturedMedia handle={this.props.handle} productName={this.props.productName} media={featured} index={this.state.index} _openImageZoom={this._openImageZoom} />
            {/* <this.productMediaTrigger />   */}
          </div>
        </div>
      </MediaQuery>
    </React.Fragment>
  }
}

ProductGallery.contextType = ProductContext;